import { Route, Routes } from "react-router-dom";
import * as React from 'react';
import Main from "./pages/Main";
import Header from "./components/Header";
import { Box, CssBaseline, CssVarsProvider } from "@mui/joy";
import Catalog from "./pages/Catalog";
import Footer from "./components/Footer";
import Payment from "./pages/Payment";
import Delivery from "./pages/Delivery";
import Installments from "./pages/Installments";
import PrivacyPolicy from "./pages/Privacy-policy";
import PublicOffer from "./pages/PublicOffer";
import Guarantee from "./pages/Guarantee";
import Return from "./pages/Return";
import About from "./pages/About";
import Contacts from "./pages/Contacts";
import Admin from "./pages/Admin";
import ProductPage from "./pages/ProductPage";
import ScrollToTop from "./components/ScrollToTop";
import Squares from "./components/ReactBits/GridMotion/Squares";
import Button from '@mui/joy/Button';
import Modal from '@mui/joy/Modal';
import ModalClose from '@mui/joy/ModalClose';
import Typography from '@mui/joy/Typography';
import Sheet from '@mui/joy/Sheet';


function App() {
  const [open, setOpen] = React.useState(true);

  React.useEffect(() => {
    if (!open) return;
    const timer = setTimeout(() => setOpen(false), 10000);
    return () => clearTimeout(timer);
  }, [open]);

  return (
    <CssVarsProvider defaultMode="light">
      <CssBaseline />
      <Squares
        speed={0.1}
        squareSize={40}
        direction='diagonal'
        borderColor='#000'
        hoverFillColor='#eee' />
      <ScrollToTop />
      <Header />
      <Routes>
        <Route element={<Main />} path="/" />
        <Route element={<Catalog />} path="/catalog" />
        <Route element={<Payment />} path="/payment" />
        <Route element={<Delivery />} path="/delivery" />
        <Route element={<Installments />} path="/installments" />
        <Route element={<PrivacyPolicy />} path="/privacy-policy" />
        <Route element={<PublicOffer />} path="/public-offer" />
        <Route element={<Guarantee />} path="/guarantee" />
        <Route element={<Return />} path="/return" />
        <Route element={<About />} path="/about" />
        <Route element={<Contacts />} path="/contacts" />
        <Route element={<Admin />} path="/admin" />
        <Route element={<ProductPage />} path="/product/:id" />
      </Routes>
      <Footer />

      <Modal
        aria-labelledby="modal-title"
        aria-describedby="modal-desc"
        open={open}
        onClose={() => setOpen(false)}
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        <Sheet
          variant="soft"
          sx={{ maxWidth: 500, borderRadius: '25px', p: 3, boxShadow: 'lg' }}
        >
          <ModalClose variant="plain" sx={{ m: 1, borderRadius: 250 }} />
          <Typography
            component="h2"
            id="modal-title"
            level="h4"
            textColor="inherit"
            sx={{ fontWeight: 'lg', mb: 1 }}
          >
            Внимание!
          </Typography>
          <Typography id="modal-desc" textColor="text.tertiary">
            Раздел "Бани, Беседки, Мотоэкипировка и Запчасти" в данный момент находится на модерации. Мы работаем над улучшением этого раздела и скоро он станет доступен для пользователей.
            <br /><br />
            Приносим извинения за возможные неудобства и благодарим за ваше понимание!

            <br /><br />
            Для уточнения информации по действующим заказам, пожалуйста, звоните по номеру: +375 (17) 388-43-87
            <br /><br />
            Наши специалисты готовы ответить на ваши вопросы и предоставить необходимую информацию. Спасибо за ваше обращение!
          </Typography>
        </Sheet>
      </Modal>
    </CssVarsProvider>
  );
}

export default App;
